import { FundsCompareReportPage } from "@funds/pages/fund-compare-report";
import { fundCompareSeachSchema } from "@funds/utils/fund-compare-search-params";
import { createFileRoute } from "@tanstack/react-router";
import {
  getDistributorBrandingOptions,
  getDistributorProfileOptions,
} from "creso-core/hooks";

export const Route = createFileRoute(
  "/(auth)/(headless)/reports/funds/compare"
)({
  component: RouteComponent,
  validateSearch: fundCompareSeachSchema,
  loader: async ({ context }) => {
    const { queryClient } = context;
    const distributorBranding = await queryClient.ensureQueryData(
      getDistributorBrandingOptions()
    );
    const distributorProfile = await queryClient.fetchQuery(
      getDistributorProfileOptions(true)
    );
    return {
      distributorBranding,
      distributorProfile,
    };
  },
});

function RouteComponent() {
  return <FundsCompareReportPage />;
}
